import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import {
  Update,
  findAOneUserPercentage,
} from "../../../utils/apis/userspercentage/index";
import { useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS, users_type } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

function Edit(props) {
  const { UnauthorizedLogOut } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    control,
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "fields",
  });

  const removeField = (index) => {
    remove(index);
  };

  const onSubmit = async (data) => {
    try {
      const result = await Update(data);
      const response = result.data;

      await setShowModal({
        code: response.code,
        message: response.message,
      });
      setTimeout(() => {
        setShowModal(0);
        props.onHide();
      }, 1000);
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const data = {
        customer_id: id,
        users_type: users_type.customers,
      };
      const response = await findAOneUserPercentage(data);
      reset({ fields: response?.data?.data });
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"Edit Percentage"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    {fields.map((field, index) => (
                      <>
                        <div className="col-md-12 col-sm-12 mt-3" key={index}>
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>
                              {field?.Module?.name} Percentage *
                            </Form.Label>
                            <Form.Control
                              type="number"
                              placeholder={`${field?.booking_type} Percentage`}
                              className={classNames("", {
                                "is-invalid":
                                  errors[`fields.${index}.percentage`],
                              })}
                              {...register(`fields.${index}.percentage`, {
                                required: `${field?.booking_type} is required`,
                              })}
                            />
                            {errors?.fields?.[index]?.percentage && (
                              <span style={errorStyle}>
                                {errors?.fields?.[index]?.percentage.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        {/* <div className="col-md-12" key={index}>
                        <div className="main-form-section mt-3 ">
                          <div className="row justify-content-center ">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Notes {index + 1}{" "}
                            </label>

                            <div className="col-sm-6">
                              <input
                                type="text"
                                name="note"
                                {...register(`fields.${index}.note`, {
                                  required: "Please Enter Note",
                                })}
                                placeholder="Enter Note"
                                // className="form-control"
                                className={`form-control ${
                                  errors?.fields?.[index]?.note
                                    ? "is-invalid"
                                    : ""
                                }`}
                                id="inputEmail3"
                              />
                              {errors?.fields?.[index]?.note && (
                                <span style={errorStyle}>
                                  {errors?.fields?.[index]?.note.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div> */}{" "}
                      </>
                    ))}
                    {/* <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "Email is required",
                          })}
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Support Contact No *</Form.Label>
                        <Form.Control
                          type="number"
                          name="support_contact_no"
                          placeholder="Support Contact No"
                          className={classNames("", {
                            "is-invalid": errors?.support_contact_no,
                          })}
                          {...register("support_contact_no", {
                            required: "Support Contact No is required",
                          })}
                        />
                        {errors.support_contact_no && (
                          <span className="text-danger">
                            {errors.support_contact_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                 
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Bus Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="bus_percentage"
                          placeholder="Bus Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.bus_percentage,
                          })}
                          {...register("bus_percentage", {
                            required: "Bus Percentage is required",
                            validate: (value) => {
                              if (!value) return "Bus Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Bus Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Bus Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.bus_percentage && (
                          <span className="text-danger">
                            {errors.bus_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div> */}

                    {/* <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Flight Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="flight_percentage"
                          placeholder="Flight Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.flight_percentage,
                          })}
                          {...register("flight_percentage", {
                            required: "Flight Percentage is required",
                            validate: (value) => {
                              if (!value)
                                return "Flight Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Flight Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Flight Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.flight_percentage && (
                          <span className="text-danger">
                            {errors.flight_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div> */}
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
